/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:stringUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社         | 新規作成
// 01.02.00 | 2022/10/11 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
//================================================================================
 */
import { co_isEmpty } from '@/common/checkUtility';

/*
 * 前後の半角空白、全角空白を削除
 * @param {String} value 対象の文字列
 * @return {String} トリム処理した文字列
 */
export function co_trim(value) {
	if (co_isEmpty(value)) {
		return value;
	} else {
		return value.replace(/(^[\x20\u3000}]+)|([\x20\u3000]+$)/g, "");
	}
}

/*
 * カンマ区切り編集
 * @param {String} value 対象の文字列
 * @return {String} カンマ区切り文字列
 */
export function co_commaSeparated(value) {
	if (co_isEmpty(value)) {
		return value;
	} else {
		return Number(value).toLocaleString();
	}
}

/*
 * 日付編集
 * @param {String} value 対象の文字列(yyyyMMMdd)
 * @return {String} yyyy年MM月dd日編集された文字列
 */
export function co_editDate(value) {
	if (co_isEmpty(value)) {
		return value;
	} else {
		if (value.length != 8) {
			return value;
		}
		return value.substring(0, 4) + '年' + value.substring(4, 6) + '月' + value.substring(6) + '日';
	}
}

/*
 * 日付編集（スラッシュ）
 * @param {String} value 対象の文字列(yyyyMMMdd)
 * @return {String} yyyy/MM/dd編集された文字列
 */
export function co_editDateSlash(value) {

	// stringへ変換
	let date = String(value);

	if (co_isEmpty(date)) {
		return date;
	} else {
		if (date.length != 8) {
			return date;
		}
		return date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6);
	}
}

/*
 * 年齢算出
 * @param {String} value 対象の文字列(yyyyMMMdd)
 * @return {String} 年齢
 */
export function co_calcAge(value) {
	if (co_isEmpty(value)) {
		return '';
	} else {
		if (value.length != 8) {
			return '';
		}

		let today = new Date();
		let birthdate = (Number(value.substring(0, 4)) * 10000) + (Number(value.substring(4, 6)) * 100) + (Number(value.substring(6)) * 1)
		let targetdate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
		return (Math.floor((targetdate - birthdate) / 10000));
	}
}

/*
 * 日時編集（スラッシュ）
 * @param {String} value 対象の文字列(yyyy/MM/dd HH:mm:ss)
 * @return {String} yyyy/MM/dd HH:mm編集された文字列
 */
export function co_editDateTimeSlash(value) {

	// stringへ変換
	let date = String(value);

	if (co_isEmpty(date)) {
		return date;
	} else {
		if (date.length != 19) {
			return date;
		}
		return date.substring(0, 16);
	}
}

/*
 * 半角英数字全角変換
 * @param {String} value 半角英数字
 * @return {String} 全角英数字
 */
export function co_zenkaku2Hankaku(value) {
	if (co_isEmpty(value)) {
		return '';
	} else {
		return String(value).replace(/[A-Za-z0-9]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
		});
	}
}

/*
 * 日付編集
 * @param {String} value 対象の文字列(yyyyMM)
 * @return {String} yyyy年MM月編集された文字列
 */
export function co_editDateNengetsu(value) {
	if (co_isEmpty(value)) {
		return value;
	} else {
		if (value.length != 6) {
			return value;
		}
		return value.substring(0, 4) + '年' + value.substring(4) + '月';
	}
}

